import { panel } from 'instantsearch.js/es/widgets';
import { isCollapsed, panelClasses, panelTemplates } from './common.js';

export const createPanel = (widgetCreator, options) => {
  const { container, attribute, label, widgetOptions = {} } = options;

  if (!attribute) {
    console.error('Attribute is required for refinement widget');
    return null;
  }

  const containerEl =
    typeof container === 'string'
      ? document.querySelector(container)
      : container;

  if (!containerEl) {
    return null;
  }

  const setupHeaderClick = () => {
    const header = containerEl.querySelector('.ais-Panel-header');
    const button = containerEl.querySelector('.ais-Panel-collapseButton');
    if (header && button) {
      header.addEventListener('click', (e) => {
        if (!e.target.closest('.ais-Panel-collapseButton')) {
          button.click();
        }
      });
    }
  };

  setTimeout(setupHeaderClick, 0);

  return panel({
    templates: {
      header: () =>
        panelTemplates.header({ widgetParams: { label, attribute } }),
      collapseButtonText: panelTemplates.collapseButtonText,
    },
    collapsed: () => isCollapsed(containerEl),
    cssClasses: {
      root: panelClasses.root.join(' '),
      header: panelClasses.header.join(' '),
      body: panelClasses.body.join(' '),
      footer: panelClasses.footer.join(' '),
      collapsedRoot: panelClasses.collapsedRoot.join(' '),
      collapseButton: panelClasses.collapseButton.join(' '),
    },
  })(widgetCreator)({
    container: containerEl,
    attribute,
    ...widgetOptions,
    transformItems: (items) => {
      return widgetOptions.transformItems
        ? widgetOptions.transformItems(items)
        : items;
    },
  });
};
